<template>
  <div class="billing-container">
    <div class="headers">
      <div class="month">
        <div class="icon-container" @click="setPreviousMonth">
          <div class="icon-chevron left darkblue" />
        </div>
        <div class="wording">{{ getDate }}</div>
        <div class="icon-container" :class="{ disabled: !canIGoNext }" @click="setNextMonth">
          <div class="icon-chevron right grey" :class="{ darkblue: canIGoNext }" />
        </div>
      </div>

      <div class="infos">
        <div class="price">{{ $t('globalPrice') }}</div>
        <div class="price">
          {{ resultBilling && resultBilling.globalPrice ? formatedGlobalPrice : `0€` }} {{ $t('vat') }}
          {{ $t('perMonth') }}
        </div>
      </div>
    </div>
    <div v-if="resultBilling && resultBilling.detailsByType" class="billing-content">
      <BillingTable :data="resultBilling" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BillingTable from '@/components/tables/BillingTable';

export default {
  components: { BillingTable },

  data() {
    return {
      date: null,
      resultBilling: null,
    };
  },

  computed: {
    ...mapGetters(['user']),

    getDate() {
      if (!this.date) return '';
      this.getData();
      return this.date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    },

    canIGoNext() {
      if (!this.date) return false;
      let date = new Date();
      return date.getTime() > this.date.getTime();
    },

    formatedGlobalPrice() {
      return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(this.resultBilling.globalPrice);
    },
  },

  async mounted() {
    this.setDateToday();
  },

  methods: {
    async getData() {
      this.resultBilling = await this.$store.dispatch('getBillingByDate', { date: this.date });
    },

    setNextMonth() {
      if (!this.canIGoNext) return;
      const now = this.date;
      let current;
      if (now.getMonth() === 11) current = new Date(now.getFullYear() + 1, 0, 1);
      else current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      this.setDateToday(current);
    },

    setPreviousMonth() {
      const now = this.date;
      let current;
      if (now.getMonth() === 0) current = new Date(now.getFullYear() - 1, 11, 1);
      else current = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      this.setDateToday(current);
    },

    setDateToday(date = new Date()) {
      let now = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours() + 2, date.getUTCMinutes(), date.getUTCSeconds());
      this.date = new Date(now);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.billing-container {
  margin: 60px 0 0;

  .headers {
    width: 100%;

    .month {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 2px;

      .wording {
        margin: 0 8px;
        width: auto;
        font-size: 20px;
        font-weight: 500;
        color: colors.$darkblue-color;
        width: 150px;
        text-align: center;

        &:first-letter {
          text-transform: uppercase;
        }
      }

      .icon-container {
        height: 100%;
        width: 15px;
        cursor: pointer;

        &.disabled {
          cursor: not-allowed;
        }
      }
    }

    .infos {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 2px solid colors.$lightblue-color;
      padding: 26px 40px;
      border-radius: 6px;
      margin: 24px 0 60px 0;
      font-size: 20px;
      font-weight: 500;
      color: colors.$lightblue-color;
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .infos {
    font-size: 16px !important;
    margin-bottom: 24px !important;
  }
}
</style>
